import openConnection from 'socket.io-client';
import { constants } from "../utils/constants";

const socket = openConnection(constants('socketUrl') ,{transports: ['websocket']});
export default socket;